import { gql } from '@apollo/client';
export const metadataUpdateCategory = gql `
  mutation MetadataUpdateCategory($documentId: ID!, $categoryId: UUID!) {
    updateFileSystemDocument(id: $documentId, input: { categoryId: $categoryId }) {
      id
      category: category2 {
        id
        metadata {
          id
          title
          marketLocaleCode
        }
      }
    }
  }
`;
